//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { fetchAll, fetch } from '@/apis/members'
import { update, _WAYTYPE } from '@/apis/memberAccountRecord'



export default {
    components: {
    },
    data() {
        //表單校驗
        const rules = {
            transactionType: [{ required: true, message: '請輸入名稱！' }],
            pointsAmount: [{ required: true, message: '請上傳封面圖！' }],
            transactionDesc: [{ required: true, message: '請輸入活動介紹！' }],
        };
        const formData = {
            transactionType: "1",
            pointsAmount: "",
            transactionDesc: "",
            memberCode: "",
            phone: "",
            amount: 0,
            amount1: 0,
        };
        return {
            config: {
                transactionType: []
            },
            id: 0,
            fileLoading: false,
            businessHours: '',
            //是否為管理員
            isAdmin: false,
            spinning: false,
            formData,
            rules,
            labelCol: { style: { width: '150px', }, },
            wrapperCol: { span: 14, },
            fileList: [],
            previewImage: undefined,
            previewVisible: false
        }
    },
    async mounted() {
        this.isAdmin = false;
        this.id = this.$route.params.id;

        await this.onPageConfig();
        if (this.id > 0) {
            await this.onPageLoad();
        }
    },
    methods: {
        async onPageConfig() {
            try {
                let _transaction_type = [];

                Object.keys(_WAYTYPE).forEach(value => {
                    _transaction_type.push({
                        id: value,
                        name: _WAYTYPE[value]
                    })
                })
                this.config.transactionType = _transaction_type;


            } catch (error) {
                this.$message.error(error.message);
            }
        },
        async onPageLoad() {
            try {
                const res = await fetch(this.id);
                if (res.code == 0) {

                    const res1 = await fetchAll({ memberCode: res.data.memberCode });
                    this.formData.id = this.id;
                    this.formData.memberCode = res.data.memberCode;
                    this.formData.email = res.data.email;
                    this.formData.name = res.data.name;
                    this.formData.phone = res.data.phone;
                    this.formData.amount = res1.data.records.length > 0 ? res1.data.records[0].paidPoints : 0;
                    this.formData.amount1 = res1.data.records.length > 0 ? res1.data.records[0].freePoints : 0;

                } else {
                    this.$message.error(res.msg);
                }
            } catch (error) {
                this.$message.error(error.message);
            }
        },

        handleOnFormValidate(e, v) {
            e.preventDefault();
            console.log('onFormValidate', v);
            this.$refs.form.validate(valid => {
                console.log(valid);
                if (valid) {
                    this.onSubmit();
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        async onSubmit(e) {
            let formFunction;

            const form = { ...this.formData };

            try {
                this.spinning = true;
                const res = await update(form);
                if (res.code == 0) {

                    setTimeout(() => {
                        this.$message.success('提交完成');
                        this.onPageLoad();
                        this.formData.pointsAmount = "";
                        this.formData.transactionDesc = "";
                        this.spinning = false;
                    }, 1000)

                    // this.$router.push('/member');
                }
            } catch (error) {
                this.$message.error(error.message);
                this.spinning = false;
            } finally {
                // this.spinning = false;
            }
        }
    }
}
